var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconPlayOutline(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 71,
    height: 71,
    viewBox: "0 0 71 71",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_4258_3859)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M69.999 35.5C69.999 54.5538 54.5528 70 35.499 70C16.4452 70 0.999001 54.5538 0.999001 35.5C0.999001 16.4462 16.4452 1 35.499 1C54.5528 1 69.999 16.4462 69.999 35.5Z",
    stroke: "white",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M50 35.9998L26.75 48.9898V23.0098L50 35.9998Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_4258_3859"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 71,
    height: 71,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconPlayOutline);
export default __webpack_public_path__ + "static/media/icon-play-outline.3502ad22cebf655f0f7982304d1031f7.svg";
export { ForwardRef as ReactComponent };